import React, { Suspense, Fragment, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

import { BASE_URL, BASE_URL_LOGIN } from './config/constant';

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Element props={true} />}</Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

const routes = [
  {
    exact: 'true',
    path: '/login',
    element: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  {
    exact: 'true',
    path: '/resetpassword',
    element: lazy(() => import('./views/auth/reset-password/ResetPassword1'))
  },
  {
    exact: 'true',
    path: '/verfiypassword',
    element: lazy(() => import('./views/auth/reset-password/VerifyPassword'))
  },
  {
    exact: 'true',
    path: '/setpassword',
    element: lazy(() => import('./views/auth/reset-password/SetPassword'))
  },
  {
    exact: 'true',
    path: '/privacy_policy',
    element: lazy(() => import('./views/auth/privacy-policy/privacy_policy'))
  },
  {
    exact: 'true',
    path: '/contact-us/',
    element: lazy(() => import('./views/auth/contactus/Contact_US'))
  },
  {
    path: '*',
    layout: AdminLayout,
    routes: [
      {
        exact: 'true',
        path: 'dashboard',
        element: lazy(() => import('./views/dashboard'))
      },
      {
        exact: 'true',
        path: 'customers',
        element: lazy(() => import('./views/tables/customers'))
      },
      // {
      //   exact: 'true',
      //   path: 'Earning',
      //   element: lazy(() => import('./views/Earning/index'))
      // },
      {
        exact: 'true',
        path: 'profilepage/:id',
        element: lazy(() => import('./views/tables/UserProfile'))
      },
      {
        exact: 'true',
        path: 'Tracking',
        element: lazy(() => import('./views/Tracking/Tracking'))
      },
      {
        exact: 'true',
        path: 'chat',
        element: lazy(() => import('./views/Chats/index'))
      },
      {
        exact: 'true',
        path: 'Setting',
        element: lazy(() => import('./views/Setting/Setting'))
      },
      {
        path: '*',
        exact: 'true',
        element: () => <Navigate to={BASE_URL_LOGIN} />
      }
    ]
  }
];

export default routes;
